import type { ModelLeadFilterData } from '@app/api/Leads/types';
import type { MultiSelectOption } from '@app/shared/components/MultiSelect/types';

const TAG_LABEL_MAX_LENGTH = 200;

// Maps the `GetLeadsFilterData` tags dictionary into MultiSelect options for
// the Leads registry tags filter. Mirrors the legacy mapping: fall back to
// `#<id>` when the name is empty and clamp the label length.
export const mapLeadsFilterDataToTagOptions = (
  filterData: ModelLeadFilterData | undefined
): MultiSelectOption[] =>
  (filterData?.Tags ?? []).map(({ Id, Name, IsDeleted }) => ({
    label: (Name?.trim() || `#${Id}`).slice(0, TAG_LABEL_MAX_LENGTH),
    value: String(Id),
    isDeleted: IsDeleted,
  }));
